import { useGraphQLQuery } from '@betterment/graphql';
import { useAutoNavigate } from '@betterment/js-runtime';
import { Box, H2, VStack } from '@betterment/samba-react';
import { ErrorBoundary, WorkflowLayout } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { Formik } from 'formik';

import { AccountCustomPortfolioDocument } from './graphql/accountCustomPortfolio.generated';
import { toCustomPortfolio } from './graphql/adapters';
import { SecurityGroupAllocationFields } from './SecurityGroupAllocationFields';

import { urlBuilder } from '../Shared/urlBuilder';

export const CustomPortfolioBuilderPage = () => {
  const accountId = useRequiredParam('accountId');

  const { data } = useGraphQLQuery(AccountCustomPortfolioDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  const navigate = useAutoNavigate();

  const handleBack = () => void navigate(urlBuilder.appAccount.absolute({ accountId }));
  const handleClose = () => void navigate(urlBuilder.appAccount.absolute({ accountId }));

  const portfolio = data ? toCustomPortfolio(data.envelopeAccount) : null;

  return (
    <ErrorBoundary fallbackType="full" feature="custom_portfolio_builder" owner="investing_experience">
      <WorkflowLayout pageTitle="Custom Portfolio">
        <WorkflowLayout.Header onBack={handleBack} onClose={handleClose} workflowTitle="Custom Portfolio" />
        <WorkflowLayout.Content size="full">
          {portfolio && (
            <Formik
              initialValues={{ securityGroupAllocations: portfolio.securityGroupAllocations }}
              onSubmit={() => {}}
            >
              <VStack css={{ gap: 'space.300' }}>
                <H2 variant="title300">Holdings</H2>
                <Box>
                  <SecurityGroupAllocationFields />
                </Box>
              </VStack>
            </Formik>
          )}
        </WorkflowLayout.Content>
      </WorkflowLayout>
    </ErrorBoundary>
  );
};
